import Input2 from './input-2/Input2';
import { removeSpaces } from '../../utils';
import { formatPhoneNumber } from '../../utils/phone-utils';
import { useState } from 'react';
import { Controller } from 'react-hook-form';
import { Input } from '@sb1/ffe-form-react';

const PhoneNumberInput = ({ defaultValue, value = '', onChange, ...props }) => {
    const { formattedValue } = format(value || defaultValue);
    const [editedValue, setEditedValue] = useState(formattedValue);

    return (
        <Input2
            {...props}
            onInput={() => {}}
            inputCreator={(inputProps, control) => {
                if (props.fieldName && control) {
                    return (
                        <Controller
                            name={props.fieldName}
                            control={control}
                            rules={inputProps.rules}
                            render={({ field: { onChange, onBlur, name, value, ref } }) => (
                                <Input
                                    {...inputProps}
                                    value={editedValue ?? value}
                                    onChange={(evt) => {
                                        const { value, formattedValue } = format(evt.target.value);
                                        setEditedValue(formattedValue);
                                        onChange && onChange({ value, formattedValue });
                                    }}
                                    type={'tel'}
                                    autoComplete={'tel'}
                                    name={name}
                                    onBlur={onBlur}
                                    ref={ref}
                                />
                            )}
                        />
                    );
                }
                return (
                    <Input
                        {...inputProps}
                        value={editedValue}
                        onChange={(evt) => {
                            const { value, formattedValue } = format(evt.target.value);
                            setEditedValue(formattedValue);
                            onChange && onChange({ value, formattedValue });
                        }}
                        type={'tel'}
                        autoComplete={'tel'}
                    />
                );
            }}
        />
    );
};

const format = (value) => {
    if (!value) {
        return { value: '', formattedValue: '' };
    }

    const valid = fixPhoneNumber(value).substring(0, 11);
    return { value: valid, formattedValue: formatPhoneNumber(valid) };
};

function fixPhoneNumber(value) {
    const trimmed = removeSpaces(value);
    if (trimmed.startsWith('+47')) {
        return trimmed;
    } else if (trimmed.startsWith('47')) {
        return '+' + trimmed;
    } else {
        return '+47' + trimmed;
    }
}

export default PhoneNumberInput;
